import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Metadata({ metadata }) {
  if (!metadata) return null;

  return (
    <Accordion sx={{ mt: 2, mb: 2, boxShadow: 1, borderRadius: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          border: "none",
          bgcolor: "grey.100",
          borderRadius: 2,
          minHeight: 48,
        }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          Product Metadata
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Box sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableBody>
              {Object.entries(metadata).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell
                    sx={{
                      fontWeight: 500,
                      textTransform: "capitalize",
                      border: "none",
                      color: "text.secondary",
                      width: "40%",
                      py: 0.5,
                    }}
                  >
                    {key === "price"
                      ? <>
                          Price <Typography component="span" variant="caption" color="text.disabled">(last updated on 4-6-25)</Typography>
                        </>
                      : key.replace(/_/g, " ")
                    }
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      py: 0.5,
                      color: value !== null ? "text.primary" : "text.disabled",
                    }}
                  >
                    {value !== null && value !== "" ? value.toString() : <em>-</em>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}